export const LINKABLE_IDENTIFIER_COLUMNS = [
  'clientIdentifier',
  'programIdentifier',
  'subjectIdentifier',
] as const;

export function trimmedIdentifier(value: string | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed != null && trimmed !== '' ? trimmed : undefined;
}

export function rowHasLinkableIdentifier(rowData: Record<string, string | undefined>): boolean {
  return LINKABLE_IDENTIFIER_COLUMNS.some((key) => trimmedIdentifier(rowData[key]) != null);
}
